import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("button", {
    onClick: _cache[1] || (_cache[1] = $event => (_ctx.share()))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}